import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, memo, useEffect } from "react";
import { useIntl } from "react-intl";
import { templateToPages } from "./templateToPages";
import { FormPages } from "./page/FormPages";
import { MissingPage } from "./page";
import { usePageState, PageStateProvider } from "./PageContext";
import { PagesProvider } from "./pagesContext";
import { RedirectToFirstError } from "./components/RedirectToErrorOnFirstMount";
import { useAppLoad } from "./appLoadContext";
import { Grid } from "@material-ui/core";
import { ProductInfo } from "./components/ProductInfo";
import { FormTemplateProvider } from "./FormTemplateContext";
import { useTemplateFieldIsVisible } from "./hooks";
export const TemplateForm = memo(({ template, independent, header, loading, error, skipOwnPageStateProvider, canSubmit = false, modalClick, modalCloseMode, disablePageVisibilityFilter, formIsDisabled }) => {
    const intl = useIntl();
    const appData = useAppLoad();
    const allPages = useMemo(() => (template ? templateToPages(intl, template, canSubmit) : []), [template, canSubmit, intl]);
    const isTemplateFieldVisible = useTemplateFieldIsVisible({
        ignoreRoles: true
    });
    const pages = useMemo(() => allPages.filter(p => {
        if (disablePageVisibilityFilter)
            return true;
        const firstField = p.panels.main?.sections[0]?.fields[0];
        if (!!firstField && firstField.role === "visibilityFilterPage")
            return isTemplateFieldVisible(firstField);
        return true;
    }), [allPages, disablePageVisibilityFilter, isTemplateFieldVisible]);
    if (process.env.NODE_ENV === "development") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        useEffect(() => {
            window.__dploy = {
                ...window.__dploy,
                template,
                pages
            };
        }, [template, pages]);
    }
    const { labels } = usePageState();
    if (pages.length === 0)
        return _jsx(MissingPage, { header: header, loading: loading, error: error });
    const templatePageLabels = allPages.map(p => (p.pageUri?.trim().length ?? 0) > 0 ? p.pageUri : p.pageTitle);
    const alreadyProvided = templatePageLabels.length === labels.length &&
        templatePageLabels.every((l, i) => l === labels[i]);
    const hasMultiplePages = templatePageLabels.length > 1;
    const shouldProvidePageState = hasMultiplePages
        ? independent || !alreadyProvided // Ensure page state is provided
        : independent && alreadyProvided; // Override page state if needed
    const productHeader = appData.settings.showProductInfo ? (_jsxs(Grid, { container: true, spacing: 2, children: [_jsx(Grid, { item: true, xs: 12, children: header }), _jsx(ProductInfo, { header: appData.productInfoHeader, productExternalCode: appData.productExternalCode })] })) : (header);
    const formPages = (_jsxs(PagesProvider, { value: pages, children: [_jsx(FormPages, { header: productHeader, pages: pages, modalClick: modalClick, modalCloseMode: modalCloseMode, stepper: template?.stepper, formIsDisabled: formIsDisabled }), _jsx(RedirectToFirstError, {})] }));
    let childrenToRender;
    if (shouldProvidePageState && !skipOwnPageStateProvider) {
        childrenToRender = (_jsx(PageStateProvider, { labels: templatePageLabels, children: formPages }));
    }
    else {
        childrenToRender = formPages;
    }
    return (_jsx(FormTemplateProvider, { value: { formTemplateId: template?.formTemplateId }, children: childrenToRender }));
});
//# sourceMappingURL=TemplateForm.js.map